import React, { createContext, useState } from 'react';
import { createContextHook } from '../contextUtils';

// ResponsiveContext manages responsive design states
const ResponsiveContext = createContext();

export function ResponsiveProvider({ children }) {
  // Current window width for responsive calculations
  const [twidth, setTWidth] = useState(window.innerWidth);
  // Current window height for responsive calculations
  const [theight, setThieght] = useState(window.innerHeight);
  // Flag to trigger responsive layout updates
  const [responsiveFlag, setResponsiveFlag] = useState(false);

  const value = {
    twidth, setTWidth,
    theight, setThieght,
    responsiveFlag, setResponsiveFlag
  };

  return (
    <ResponsiveContext.Provider value={value}>
      {children}
    </ResponsiveContext.Provider>
  );
}

export const useResponsive = createContextHook(ResponsiveContext, 'useResponsive');